export default __webpack_public_path__ + "static/media/location.6b4fe60e.svg";